import { EyeOff, PencilLine, Trash2 } from "lucide-react";
import { Col, Row } from "react-bootstrap";
import { HiOutlineEllipsisVertical } from "react-icons/hi2";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Config } from "@pages/configs/config";

const Listing = ({ t, mode, data, handleChangeStatus, profile }) => {
  const config = new Config(t);

  return (
    <>
      {data.map((item, index) => (
        <div
          key={index}
          className={`my-3 p-3 rounded w-100 ${config.userBorderColor(
            item.status
          )} ${
            mode === "dark" ? "bg-dark text-white" : "border bg-white text-dark"
          }`}
          style={{ borderColor: "#ff0000!important" }}
        >
          <Row className="justify-content-between align-items-center">
            <Col md="1" className="my-1">
              <img
                className="rounded-circle"
                src={`https://mannatthemes.com/rizz/default/assets/images/users/avatar-4.jpg`}
                alt={item.full_name}
                width="45"
                height="45"
              />
            </Col>
            <Col md="3" className="my-1">
              <div className="fs-6">{item.full_name}</div>
            </Col>

            <Col md="3" className="my-1">
              <div className="fs-6 fw-light">{item.phone}</div>
            </Col>
            <Col md="2" className="my-1">
              <div className="fs-6 fw-light">{item.email}</div>
            </Col>
            <Col md="2" className="my-1">
              <div className="fs-6 fw-light">{item.created_at}</div>
            </Col>
            <Col
              md="1"
              className="product-dropdown d-flex justify-content-end my-1"
            >
              <NavDropdown
                title={
                  <div role="button">
                    <HiOutlineEllipsisVertical size={25} />
                  </div>
                }
                menuVariant="light"
              >
                <a
                  href={`/users/${item.id}`}
                  className="d-flex align-items-center px-3 py-2 text-dark"
                >
                  <span>
                    <PencilLine size={15} strokeWidth={1.5} />{" "}
                  </span>
                  <span className="mx-2">{t("edit")}</span>
                </a>

                {profile.id != item.id && (
                  <div
                    className="d-flex align-items-center px-3 py-2"
                    onClick={() => handleChangeStatus(item, index)}
                  >
                    <span>
                      <EyeOff size={15} strokeWidth={1.5} />{" "}
                    </span>
                    <span className="mx-2">
                      {config.userStatusAction(item.status)}
                    </span>
                  </div>
                )}
              </NavDropdown>
            </Col>
          </Row>
        </div>
      ))}
    </>
  );
};

export default Listing;
